import { combineReducers } from 'redux';
import { createScopedReducer } from '@mews/framework';
import { INTERVAL_FILTER_VALUES_SET, DATE_FILTER_VALUES_SET, HEATMAP_FILTER_VALUES_SET } from '../actionTypes';
import { FilterValues, ReportMode } from '../types';

const initialState = {};

const createScopedFilterReducer = (actionType: string) =>
    createScopedReducer(initialState, {
        [actionType]: (_: unknown, filterValues: FilterValues) => filterValues,
    });

const intervalFilterReducer = createScopedFilterReducer(INTERVAL_FILTER_VALUES_SET);
const dateFilterReducer = createScopedFilterReducer(DATE_FILTER_VALUES_SET);
const heatmapFilterReducer = createScopedFilterReducer(HEATMAP_FILTER_VALUES_SET);

const metaReducer = combineReducers({
    [ReportMode.Interval]: intervalFilterReducer,
    [ReportMode.Date]: dateFilterReducer,
    [ReportMode.OccupancyHeatmap]: heatmapFilterReducer,
    [ReportMode.AvailabilityHeatmap]: heatmapFilterReducer,
});

export default metaReducer;
